// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"w8-z"};